import Nullstack from 'nullstack';
export default function IconDropletFilled2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-droplet-filled-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), "   ", Nullstack.element("path", {
    d: "M6 14h12"
  }), "   ", Nullstack.element("path", {
    d: "M7.305 17.695l3.695 -3.695"
  }), "   ", Nullstack.element("path", {
    d: "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
  }), " ");
}